import moment from "moment";

export const paginateData = (rows, data, page) => {
  const startIndex = rows * (page - 1);
  const endIndex = rows * page;
  return data.slice(startIndex, endIndex);
};

export const getFormattedDate = (timestamp) => {
  let formattedDate = moment(timestamp).utc().format("MMM DD YYYY");
  return formattedDate;
};
